/** @format */

import React from 'react';
import styled from 'styled-components';

const StyledSettingWrapper = styled.div`
  h2 {
    text-align: center;
  }
`;

function SettingWrapper(props) {
  return <StyledSettingWrapper>{props.children}</StyledSettingWrapper>;
}

export default SettingWrapper;
